<template>
  <div class="btn-filter" :class="setClassModifiers('btn-filter--')" v-scrollable>
    <v-button
      v-for="item of computedItems"
      :key="item.value"
      :inactive="!item.active"
      @click="change(item)"
      size="small"
      class="text--normalcase"
    >
        {{item.name}}
    </v-button>
    <div class="btn-filter__whitespace-right"></div>
  </div>
</template>

<script>
import vButton from '@/ui/controls/vButton'

import setClassModifiers from '@/mixins/setClassModifiers'

import scrollable from '@/directives/scrollable'

export default {
  mixins: [setClassModifiers],

  directives: { scrollable },

  components: {
    vButton
  },

  props: {
    activeFilter: {
      type: Object,
      default: () => {
        return {
          value: 0,
          name: 'Test'
        }
      }
    },

    filters: {
      type: Array,
      default: () => [
        {
          value: 0,
          name: 'Test'
        }
      ]
    },

    noPadding: {
      type: Boolean,
      default: false
    },

    vertical: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    computedItems () {
      const activeFilter = this.activeFilter
      return this.filters.map(item => {
        if (item.value === activeFilter.value) {
          item.active = true
          return item
        }
        item.active = false
        return item
      })
    }
  },

  methods: {
    change (item) {
      this.$emit('update:activeFilter', item)
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="scss">
  .btn-filter {
    display: flex;
    overflow-x: scroll;
    white-space: nowrap;

    & > * {
      flex-grow: 0;
    }

    &--vertical {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    @supports (scrollbar-width: none) {
      scrollbar-width: none;
    }
    &::-webkit-scrollbar {
      display: none;
    }

    &__whitespace-right {
      padding-right: $default-spacing-mobile;
    }

    &--no-padding {
      padding-left: 0;
      .btn-filter__whitespace-right {
        padding-right: 0;
      }
    }

    &--vertical {
      .btn-filter__whitespace-right {
        display: none;
      }
    }

    & > *:not(:nth-last-child(2)) {
      margin-right: 1rem;
    }

    &--vertical {
      & > *:not(:nth-last-child(2)) {
        margin-right: 0;
        margin-bottom: 1rem;
      }
    }

    & > *:last-child {
      margin-right: 0;
    }
  }
</style>
